'use client';
import { useLayoutEffect, useEffect } from 'react';

// useLayoutEffect показывает warning если используется во время ssr, например с Next.js
// useIsomorphicEffect убирает это поведение заменяя useLayoutEffect на useEffect во время ssr
var useIsomorphicEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;

export { useIsomorphicEffect };
